import React from 'react';
import { Button, Link, Typography } from '@mui/material';
import '../App.css';
import SignIn from '../Components/SignIn';

function Login() {
  return (
    <div className="App">
      <div id="page-content">
        <SignIn />
      </div>
    </div>
  );
}

export default Login;
